import { Injectable } from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {ApiInterfaceCustomerModel} from "../../models/resources/api-interface-customer.model";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class ApiInterfaceCustomerService extends AResourceService<ApiInterfaceCustomerModel> {
  constructor() {
    super('/api-interface-customers', true, ['apiInterface','customer']);
  }

  /**
   * Die Kundenliste einer Schnittstelle zeigt nur Hauptdatensätze –
   * Kontakte (Child-Kunden) sind zwar mitverknüpft, werden aber über den
   * Kontakte-Tab des jeweiligen Kunden verwaltet.
   */
  protected override getDefaultListParams(): UrlParamModel[] {
    return [{ key: 'only-main', value: 'true' }];
  }

  setApiInterfaceId(id: number) {
    this.setResourceUrl(`/api-interfaces/${id}/api-interface-customers`)
  }

  removeApiInterfaceId() {
    this.setResourceUrl(`/api-interface-customers`);
  }
}
